import formulaHeroDesktop from 'assets/images/prose-product-ingredients-desktop.jpg';
import formulaHeroMobile from 'assets/images/prose-product-ingredients-mobile.jpg';
import formulaHeroTablet from 'assets/images/prose-product-ingredients-tablet.jpg';

export const introHeroTitle = ' your results are in!';

export const consultationScoringImages = {
  mobile: formulaHeroMobile,
  tablet: formulaHeroTablet,
  desktop: formulaHeroDesktop,
};

// hair profile
export const scoringGoals = {
  getGoalValue: value => [
    {
      name: 'Sensitivity',
      value: value.sensitivity,
      description:
        '**Sensitivity** is how prone your scalp is to irritation, itchiness, or discomfort. We’ll customize for maximum relief.',
      keyQuestions: `**Key questions that drive this score:**
   - Does your scalp feel more comfortable?
   - In an average week, where do you workout?
   - How often do you wash your hair?
   - How often are you stressed out?`,
      minLabel: 'Not sensitive',
      maxLabel: 'Very sensitive',
    },

    {
      name: 'Sebum',
      value: value.sebum,
      description:
        '**Sebum** is how your scalp is producing oil, both naturally and in response to external factors. We’ll help keep your levels in check.',
      keyQuestions: `**Key questions that drive this score:**
  - After a wash, how long until hair gets oily again?
  - Where would you put your hair on the oily/dry spectrum?
  - What makes up the majority of your diet?`,
      minLabel: 'Not prone to oil',
      maxLabel: 'Very prone to oil',
    },
    {
      name: 'Dryness',
      value: value.dryness,
      description:
        '**Dryness** is how much your hair needs moisture and nutrition. We’ll help quench the thirst.',
      keyQuestions: `**Key questions that drive this score:**
  - Do you get split ends?
  - How porous is your hair?
  - How often do you curl or flat-iron your hair?`,
      minLabel: 'Well moisturized',
      maxLabel: 'Needs moisture',
    },
    {
      name: 'Damage',
      value: value.damaged,
      description:
        '**Damage** is how much your hair is weakened by hair treatments. We’ll strengthen your hair and help repair what we can.',
      keyQuestions: `**Key questions that drive this score:**
  - Is your hair color-treated?
  - How often do you color-treat your hair?
  - Has your hair undergone any textural treatments?
  - How often do you receive textural treatments?
  - Do you get split ends?`,
      minLabel: 'Low damage',
      maxLabel: 'Very damaged',
    },
    {
      name: 'Stressors',
      value: value.stress,
      description:
        '**Stressors** is how much your scalp and hair are impacted by environmental or emotional stress. We’ll fortify your formulas with extra defenses.',
      keyQuestions: `**Key questions that drive this score:**
  - Do you feel like you’re shedding more than usual lately?
  - How often are you stressed out?`,
      minLabel: 'Low stress',
      maxLabel: 'High stress',
    },
  ],
};
export const scoringSectionDescription =
  "Based on today's answers, your hair and scalp require targeted support in these key areas. Your formulas will reflect these exact needs.";

export const scroringModalScoreLabel = (name, score) => `You scored ${score}/100 for ${name}`;

export const bcorpTitle = 'prose philosophy';
export const bcorpDesc1 =
  'Our goal is to give back more than we take—to make a positive impact on our customers, our suppliers, and the earth itself.';
export const bcorpDesc2 =
  'To do that, we’ve cut our carbon and have offset the rest to become the first and only carbon-neutral custom beauty brand since our start in 2017.';
